import axiosInstance from '../utils/axios';

/**
 * 약관 및 개인정보 처리방침 관련 API 서비스
 */
const termsService = {
  /**
   * 약관 또는 개인정보 처리방침 조회
   * @param {number} kind 1: 이용약관, 2: 개인정보처리방침
   * @returns {Promise<Object>} 약관 또는 개인정보 처리방침 정보
   */
  async getTerms(kind) {
    const response = await axiosInstance.get('/terms/current', {
      params: { kind }
    });
    
    if (response.data.success &&  response.data.data?.version > 0) {
      return {
        contentKo: response.data.data.content_ko || '',
        contentEn: response.data.data.content_en || ''
      };
    }
    
    throw new Error(response.data.message || '정보를 불러오는 중 오류가 발생했습니다.');
  },
  
  /**
   * 약관 또는 개인정보 처리방침 업데이트
   * @param {number} kind 1: 이용약관, 2: 개인정보처리방침
   * @param {string} contentKo 한국어 내용
   * @param {string} contentEn 영어 내용
   * @returns {Promise<Object>} 업데이트 결과
   */
  async updateTerms(kind, contentKo, contentEn) {
    const response = await axiosInstance.post('/terms', {
      kind,
      content_ko: contentKo,
      content_en: contentEn
    });
    
    if (response.data.success) {
      return { 
        success: true,
        message: '정보가 변경되었습니다.'
      };
    }
    
    throw new Error(response.data.message || '정보 변경 중 오류가 발생했습니다.');
  },
  
  /**
   * 약관 또는 개인정보 처리방침 히스토리 조회
   * @param {number} kind 1: 이용약관, 2: 개인정보처리방침
   * @param {number} page 페이지 번호
   * @param {number} pageSize 페이지당 항목 수
   * @returns {Promise<Object>} 히스토리 목록 및 총 개수
   */
  async getTermsHistory(kind, page = 1, pageSize = 10) {
    const response = await axiosInstance.get('/terms/history', {
      params: {
        kind,
        pageSize,
        page
      }
    });
    
    if (response.data.success) {
      return {
        items: response.data.data.items || [],
        totalCount: Number(response.data.pagination?.totalCount)
      };
    }
    
    throw new Error(response.data.message || '히스토리를 불러오는 중 오류가 발생했습니다.');
  }
};

export default termsService;
